// extracted by mini-css-extract-plugin
export default {"grid":"Grid-module--grid--7bc68","threePerRow":"Grid-module--threePerRow--7aaec"};